import gql from 'graphql-tag';

export const MUTATION = gql`
  mutation createUser(
    $communityId: String = ""
    $auth0User: String = ""
    $displayName: String
    $roles: [String]
    $url: String
    $email: String
    $firstName: String
    $lastName: String
    $zipCode: String
    $originatingSite: String
    $city: String
    $jobTitle: String
    $image: String
    $urls: [String]
    $bio: String
    $status: String
    $imageId: String
  ) {
    createUser(
      input: {
        communityId: $communityId
        auth0User: $auth0User
        displayName: $displayName
        roles: $roles
        url: $url
        email: $email
        firstName: $firstName
        lastName: $lastName
        zipCode: $zipCode
        originatingSite: $originatingSite
        city: $city
        jobTitle: $jobTitle
        image: $image
        urls: $urls
        bio: $bio
        status: $status
        imageId: $imageId
      }
    ) {
      user {
        atid
        auth0User
        communityId
        displayName
        roles
        url
        email
        firstName
        lastName
        zipCode
        originatingSite
        city
        jobTitle
        image
        urls
        bio
        status
        imageId
      }
    }
  }
`;

export default MUTATION;
